import { Button, Icon, IconButton, List, ListItem, ListItemIcon, ListItemText, MenuList, Paper, Popover, Tabs, Typography } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Fragment, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import admindrawer from "../../../json/mpsdrawer/admindrawer";
import drawer from "../../../json/mpsdrawer/drawer";
import drawerexternal from "../../../json/mpsdrawer/drawerexternal";
import drawerexternalnonadmin from "../../../json/mpsdrawer/drawerexternalnonadmin";
import notadmindrawer from "../../../json/mpsdrawer/drawerinternal";
import noregistrationdrawer from "../../../json/mpsdrawer/noregistrationdrawer";
import systemadmindrawer from "../../../json/mpsdrawer/systemadmindrawer";
import { getEnvVariable } from "../../../modules/environmentalList";



import { AddCircleOutline } from "@material-ui/icons";
import Menu from "@material-ui/icons/Menu";
const useStyles = makeStyles((theme) => ({
    selected: {
        backgroundColor: '#ede7f6',
        color: ' #5e35b1',
        //backgroundColor: 'rgb(215 225 229)',
        // backdropFilter: 'blur(10px)',
        // border: '1px solid #00355f',
        //     boxShadow: '0 1px 0px 0 #00355f, 0 0px 0px 0 #00355f',
        //borderRadius: '10px',

    },
    hiddenIcon: {
        display: 'none',
    },
    parent: {
        '&:hover $hiddenIcon': {
            display: 'block',
        },
    },
    textWithSpace: {
        marginRight: '20px',
    },
}));

export default function SidebartabView() {
    let user = localStorage.getItem('profile') ? JSON.parse(localStorage.getItem('profile')) : null;
    let submodules = localStorage.getItem('submodule') ? JSON.parse(localStorage.getItem('submodule')) : null;
    const classes = useStyles();
    const [displaydrawer, setDislaydrawer] = useState(notadmindrawer);
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentTab, setCurrentTab] = useState(null)
    const history = useHistory()
    const location = useLocation();
    const [anchorMobileEl, setAnchorMobileEl] = useState(null);

    const handleMobileClick = (event) => {
        setAnchorMobileEl(event.currentTarget);
    };

    const handleMobileClose = () => {
        setAnchorMobileEl(null);
    };

    const handleClick = (event, index) => {
        setAnchorEl(event.currentTarget);
        setCurrentTab(index)
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleTabClick = (item) => {
        if (item.newtab) {
            setAnchorEl(null);
            let tempurl = window.location.href
            window.open(item.link, '_blank');
            window.location.reload(tempurl);
        }
        else {
            setAnchorEl(null);
           // window.open('#' + item.link, '_self');
            //window.location.reload();
            history.push(item.link)
        }
    }

    useEffect(() => {
        let displaydrawer = notadmindrawer
        if (getEnvVariable('AccessPortal') === 'I') {
            if (user) {
                if (user.isSystemAdmin === 'Y' && user.isSuperAdmin === 'Y' && user.isAdmin === 'Y' && user.isRequestAdmin === 'Y') {
                    displaydrawer = systemadmindrawer;
                }
                else if (user.isSystemAdmin === 'N' && user.isSuperAdmin === 'Y' && user.isAdmin === 'Y' && user.isRequestAdmin === 'Y') {
                    displaydrawer = drawer;
                }
                else if (user.isSystemAdmin === 'N' && user.isSuperAdmin === 'N' && user.isAdmin === 'Y' && user.isRequestAdmin === 'Y') {
                    displaydrawer = admindrawer;
                }
                else if (user.isSystemAdmin === 'N' && user.isSuperAdmin === 'N' && user.isAdmin === 'Y' && user.isRequestAdmin !== 'Y') {
                    displaydrawer = noregistrationdrawer;
                }
                else if (user.isSystemAdmin === 'Y' && user.isSuperAdmin === 'Y' && user.isAdmin === 'Y' && user.isRequestAdmin !== 'Y') {
                    displaydrawer = noregistrationdrawer;
                }
                // else if (user.isSuperAdmin === 'N' && user.isAdmin === 'N' && user.isRequestAdmin === 'Y') {
                //     displaydrawer = notadmindrawer;
                // }
                // else if (user.isAdmin === 'N') {
                //     displaydrawer = notadmindrawer;
                // }
                else displaydrawer = notadmindrawer;
            }
        }
        else {
            let type = user && user.roles && user.roles.length > 0 &&
                Object.keys(user.roles) && Object.keys(user.roles).length > 0 && Object.keys(user.roles).some(each => user.roles[each] === 'Official') ? 'O' : 'P'
            switch (type) {
                case 'O': displaydrawer = drawerexternal;
                    break;
                default: displaydrawer = drawerexternalnonadmin
            }
        }
        setDislaydrawer(displaydrawer)
    }, [user])
    //   console.log(displaydrawer)

    const handleNewClick = (event, item) => {
        event.stopPropagation(event);
        history.push(item.link + '/new')
    }

    const PopoverMenu = (each) => {
        return (<Popover
            id="simple-popover"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
        >
            <List>
                {each.items.map((item, itemindex) => { // onhover: 
                    if (item.title === 'Records') {
                        return submodules.map((eachsub, subindex) => {
                            return <Link to={eachsub.link} key={subindex} className={classes.parent}>
                                <ListItem button onClick={() => handleTabClick(eachsub)} className={item.link === location.pathname ? classes.selected : classes.listItem}>
                                    <ListItemIcon ><Icon style={{ color: eachsub.color }}>{eachsub.materialicon}</Icon></ListItemIcon>
                                    <ListItemText primary={eachsub.title} className={classes.textWithSpace} />
                                     {/* Quick links - removed for LAAOCS- Vijaya */}
                                    {/* <Link onClick={(event) => handleNewClick(event, eachsub)}
                                    >   <ListItemIcon className={classes.hiddenIcon}><AddCircleOutline /></ListItemIcon></Link> */}
                                    {/* { on hover &&add onclik } */}
                                </ListItem>
                            </Link>
                        })
                    }
                    else return <Link to={item.link} key={itemindex} >
                        <ListItem button onClick={() => handleTabClick(item)} className={item.link === location.pathname ? classes.selected : classes.listItem}>
                            <ListItemIcon ><Icon style={{ ...item.style }}>{item.materialicon}</Icon></ListItemIcon>
                            <ListItemText primary={item.title} />
                        </ListItem></Link>

                })}
                {/* <ListItem button > */}
                {/* <ListItemIcon><Icon>add</Icon></ListItemIcon> Add your icon here */}
                {/* <ListItemText primary='Quick' /> */}
                {/* </ListItem> */}
            </List>

        </Popover>
        )
    }

    const PopoverMenuMobile = () => {
        return (<Popover
            id="simple-popover"
            anchorEl={anchorMobileEl}
            open={Boolean(anchorMobileEl)}
            onClose={handleMobileClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
        >
            <>
                {displaydrawer && displaydrawer.options && displaydrawer.options.items && displaydrawer.options.items.length > 0 &&
                    displaydrawer.options.items.map((each, index) => {
                        return <Fragment key={index}>
                            <Typography variant='caption'>
                                <Icon className="mx-3" style={{ fontSize: '14px', color: each.color }}>{each.materialicon}</Icon> {each.title + '  '}
                            </Typography>
                            {each.items && each.items.length > 0 &&
                                <List className="ms-3">
                                    {each.items.map((item, itemindex) => { // onhover: 
                                        if (item.title === 'Records') {
                                            return submodules && submodules.length > 0 && submodules.map((eachsub, subindex) => {
                                                return <Link to={eachsub.link} key={subindex} className={classes.parent}>
                                                    <ListItem button onClick={() => handleTabClick(eachsub)} className={item.link === location.pathname ? classes.selected : classes.listItem}>
                                                        <ListItemIcon ><Icon style={{ color: eachsub.color }}>{eachsub.materialicon}</Icon></ListItemIcon>
                                                        <ListItemText primary={eachsub.title} className={classes.textWithSpace} />
                                                        <Link onClick={(event) => handleNewClick(event, eachsub)}
                                                        >   <ListItemIcon className={classes.hiddenIcon}><AddCircleOutline /></ListItemIcon></Link>
                                                        {/* { on hover &&add onclik } */}
                                                    </ListItem>
                                                </Link>
                                            })
                                        }
                                        else return <Link to={item.link} key={itemindex} >
                                            <ListItem button onClick={() => handleTabClick(item)} className={item.link === location.pathname ? classes.selected : classes.listItem}>
                                                <ListItemIcon ><Icon style={{ ...item.style }}>{item.materialicon}</Icon></ListItemIcon>
                                                <ListItemText primary={item.title} />
                                            </ListItem></Link>

                                    })}
                                </List>
                            }</Fragment>
                    })}
            </>
        </Popover>
        )
    }


    const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));
    return (
        <>
            <Paper square className="col-12" elevation={0}>
                {isMobile ? <>   <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <IconButton color="primary" aria-label="menu" size="small" onClick={handleMobileClick}>
                        <Menu />
                    </IconButton>
                </div>
                    {PopoverMenuMobile(displaydrawer)}
                </> :
                    <Tabs
                        indicatorColor="primary"
                        textColor="secondary"
                        aria-label="disabled tabs example"
                        className="col-12"
                        variant="scrollable"
                        //  variant="fullWidth"
                        scrollButtons={displaydrawer && displaydrawer.options && displaydrawer.options.items
                            && displaydrawer.options.items.length > 6 ? "on" : "off"}
                        value={currentTab}
                    >
                        {displaydrawer && displaydrawer.options && displaydrawer.options.items && displaydrawer.options.items.length > 0 &&
                            displaydrawer.options.items.map((each, index) => {
                                return <Fragment key={index}>
                                    <Button onClick={(e) => handleClick(e, index)} style={{ color: '#364152' }}>
                                        <Icon className="mx-3" style={{ fontSize: '14px', color: each.color }}>{each.materialicon}</Icon> {each.title + '  '}
                                        <Icon style={{ fontSize: '14px', marginLeft: '8px', color: '#364152' }}>keyboard_arrow_right</Icon>
                                    </Button>
                                    {each.items && each.items.length > 0 && index === currentTab &&
                                        PopoverMenu(each)
                                    }

                                    {/* <Divider style={{ backgroundColor: 'grey' }} orientation="vertical" flexItem /> */}
                                </Fragment>
                            })}
                    </Tabs>}
            </Paper>

        </>

    )
}

//selected={item.link === location.pathname}